import { Helmet } from 'react-helmet-async';
// sections
import { ListLoSamView } from 'src/sections/losam/view';

// ----------------------------------------------------------------------

export default function LoSamListPage() {
  return (
    <>
      <Helmet>
        <title> Quản trị: Lô sâm</title>
      </Helmet>

      <ListLoSamView />
    </>
  );
}
